export const CSS_COLOR_MODEL = {
    hex: 'HEX',
    rgba: 'RGBA',
    rgb: 'RGB',
    lab: 'LAB',
    hsl: 'HSL',
    transparent: 'TRANSPARENT',
    colorName: 'COLOR_NAME',
};
